module.exports = __webpack_public_path__ + "static/img/wq-1.6353ea8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/wq-1.png
// module id = zrKQ
// module chunks = 0